/* Preserve store names while allowing surrounding copy to be translated. */
(() => {
  if (window.hihiBrandNameInitialized) return;
  window.hihiBrandNameInitialized = true;
  const names = /\b(?:hihi\s+luxury|hihithailand|hihibag)\b/gi;
  const excluded = 'script,style,noscript,textarea,input,select,svg,head,[contenteditable="true"],.notranslate,[translate="no"]';
  const pending = new Set();
  let queued = false;

  function protect(node) {
    if (!node.isConnected) return;
    if (node.nodeType === Node.TEXT_NODE) {
      const parent = node.parentElement;
      if (!parent || parent.closest(excluded)) return;
      const matches = [...node.data.matchAll(names)];
      if (!matches.length) return;
      const fragment = document.createDocumentFragment();
      let offset = 0;
      for (const match of matches) {
        fragment.append(document.createTextNode(node.data.slice(offset, match.index)));
        const brand = document.createElement('span');
        brand.className = 'notranslate';
        brand.setAttribute('translate', 'no');
        brand.dataset.hihiBrandName = match[0];
        brand.textContent = match[0];
        fragment.append(brand);
        offset = match.index + match[0].length;
      }
      fragment.append(document.createTextNode(node.data.slice(offset)));
      node.replaceWith(fragment);
    } else if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.DOCUMENT_NODE) {
      if (node.nodeType === Node.ELEMENT_NODE && node.closest(excluded)) return;
      const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);
      textNodes.forEach(protect);
    }
  }

  function flush() {
    queued = false;
    const nodes = [...pending];
    pending.clear();
    for (const node of nodes) {
      const el = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
      const brand = el?.closest('[data-hihi-brand-name]');
      if (brand) {
        if (brand.textContent !== brand.dataset.hihiBrandName) brand.textContent = brand.dataset.hihiBrandName;
      } else protect(node);
    }
  }
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') pending.add(record.target);
      else {
        if (record.target.closest?.('[data-hihi-brand-name]')) pending.add(record.target);
        record.addedNodes.forEach(node => pending.add(node));
      }
    }
    if (!queued && pending.size) { queued = true; queueMicrotask(flush); }
  }).observe(document.documentElement, { subtree: true, childList: true, characterData: true });
  protect(document.body || document.documentElement);
})();
